import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";

import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BriefService } from "../../services/brief.service";

export function useUpdateBriefAiSettings() {
  const { setBrief } = useBriefStore();

  const {
    mutate: updateBriefAiSettings,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation({
    mutationFn: ({
      briefId,
      isCreatorFitCheckEnabled,
      brandId,
      aiOverview,
    }: {
      briefId: string;
      isCreatorFitCheckEnabled: boolean;
      brandId: string;
      aiOverview?: string;
    }) =>
      BriefService.updateBriefAiSettings({
        briefId,
        isCreatorFitCheckEnabled,
        brandId,
        aiOverview,
      }).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, response, data) => {
      ToastService.success("Brief Updated Successfully");
      c.setQueryData([...BRIEF_LIST_QUERY_KEY, data.briefId], response);
      if (response?.data) {
        setBrief(response.data, data.briefId);
      }
    },
  });

  return {
    updateBriefAiSettings,
    isUpdating,
    isUpdated,
  };
}
